import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getLatestProductCatalogueSnapshot } from '../clients/one-port.api';

export const onePortProductCatalogue = createQueryKeys('onePortProductCatalogue', {
    latest: {
        queryKey: null,
        queryFn: getLatestProductCatalogueSnapshot,
    },
});
